import Button from "react-bootstrap/Button"
import useT from "utils/hooks/useT"

export default function IntegrationResultMessage({ resultMessage, setResultMessage }) {
    const { t } = useT("common")
    return (
        <>
            {!!(
                resultMessage.amounts.project?.created ||
                resultMessage.amounts.project?.updated ||
                resultMessage.amounts.project?.skipped ||
                resultMessage.amounts.project?.deleted
            ) && (
                    <>
                        <h4>{t("projects")}</h4>
                        <ul className="list-group">
                            <li className="list-group-item">{t("labelCreated", { count: resultMessage.amounts.project?.created })}</li>
                            <li className="list-group-item">{t("labelUpdatedInformation", { count: resultMessage.amounts.project?.updated })}</li>
                            <li className="list-group-item">{t("labelAlreadyLoaded", { count: resultMessage.amounts.project?.skipped })}</li>
                            <li className="list-group-item">{t("labelDeleted", { count: resultMessage.amounts.project?.deleted })}</li>
                        </ul>
                    </>
                )}
            {
                !!(
                    resultMessage.amounts.action?.created ||
                    resultMessage.amounts.action?.updated ||
                    resultMessage.amounts.action?.skipped ||
                    resultMessage.amounts.action?.deleted
                ) && (
                    <>
                        <h4>{t("actions")}</h4>
                        <ul className="list-group">
                            <li className="list-group-item">{t("labelCreated", { count: resultMessage.amounts.action?.created })}</li>
                            <li className="list-group-item">
                                {t("labelUpdatedInformation", { count: resultMessage.amounts.action?.updated })}
                            </li>
                            <li className="list-group-item">{t("labelAlreadyLoaded", { count: resultMessage.amounts.action?.skipped })}</li>
                            <li className="list-group-item">
                                {t("labelDeletedOrFinished", { count: resultMessage.amounts.action?.deleted })}
                            </li>
                        </ul>
                    </>
                )
            }
            {
                !!(
                    resultMessage.amounts.sample?.created ||
                    resultMessage.amounts.sample?.updated ||
                    resultMessage.amounts.sample?.skipped ||
                    resultMessage.amounts.sample?.deleted
                ) && (
                    <>
                        <h4>{t("samples")}</h4>
                        <ul className="list-group">
                            <li className="list-group-item">{t("labelCreated", { count: resultMessage.amounts.sample?.created })}</li>
                            <li className="list-group-item">{t("labelUpdatedInformation", { count: resultMessage.amounts.sample?.updated })}</li>
                            <li className="list-group-item">{t("labelAlreadyLoaded", { count: resultMessage.amounts.sample?.skipped })}</li>
                            <li className="list-group-item">{t("labelDoneDeleted", { count: resultMessage.amounts.sample?.deleted })}</li>
                        </ul>
                    </>
                )
            }
            {
                !Object.values(resultMessage.amounts).reduce(
                    (hasChanges, amounts) =>
                        Object.values(amounts).reduce((hasChanges, value) => hasChanges || !!value, hasChanges),
                    false
                ) && <h4>{t("noDataFound")}</h4>
            }
            {resultMessage.errors.length > 0 && <div className="Pheading">{t("followingErrorsWhileImporting")}</div>}
            {
                resultMessage.errors.length > 0 && (
                    <ul className="list-group">
                        {resultMessage.errors.map((err) => (
                            <li className="list-group-item" key={err.file + err.sheet + err.row}>
                            {err.file}/{err.sheet}
                                {err.row !== null ? t("rowNumber", { row: err.row }) : ""}: {err.message}
                            </li>
                        ))}
                    </ul>
                )
            }
            <Button className="close-popup-button" variant="primary" onClick={() => setResultMessage(null)}>
                {t("ok")}
            </Button>
        </>
    )

}
